<template>
  <section class="section-ourmenu bg2-pattern p-t-75 p-b-120">
    <div class="container">
      <div class="title-section-ourmenu t-center m-b-22">
        <span class="tit2 t-center">How to Come</span>
        <h3 class="tit5 t-center m-t-2">如何來基隆</h3>
      </div>
      <div class="row">
        <div class="col-md-12">
          <!-- mapquest 會在 id : top_div 自動生成 style = position: relative , 造成 scroll 時蓋住 header問題 ,;-->
          <div class="row" style="padding:5%;">
            <div id="top_div">
              <!-- <l-map :zoom="zoom" :center="center">
                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                <v-marker :lat-lng="marker"></v-marker>
              </l-map>-->
            </div>
            <div class="plugin-sidebar">
              <div class="sidebar-top">
                <div class="hrefAttr" v-on:click="tagAllStops">全部</div>
                <div class="hrefAttr" v-on:click="tagDowntown">市區</div>
                <div class="hrefAttr" v-on:click="tagNorthCoast">北海岸</div>
                <div class="hrefAttr" v-on:click="tagNortheastCorner">東北角</div>
                <div class="hrefAttr" v-on:click="tagMountainArea">山區.農場</div>
              </div>

              <vue-dropdown
                :config="config"
                @setSelectedOption="setNewSelectedOption($event);"
                @busline="busLine($event);"
              ></vue-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
#top_div {
  position: sticky !important;
  width: calc(100% - 250px);
  height: 700px;
}
.plugin-sidebar {
  height: 700px;
  width: 220px;
  background-color: #393939;
  position: relative;
  overflow-y: auto;
}
.sidebar-top .hrefAttr {
  height: 22px;
  font-family: Roboto;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin-left: 15px;
  display: inline-block
}
.sidebar-top .hrefAttr:focus {
  outline: none !important;
}
.sidebar-top .hrefAttr:hover {
	text-decoration: none;
  color: #FFBB00;
  cursor: pointer;
}
.sidebar-top {
  width: 220px;
  height: 50px;
  object-fit: contain;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: auto;
  margin-top: 17px;
}

#testbutton {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.leaflet-container >>> .leaflet-marker-pane {
  display: none;
}
.leaflet-container >>> .leaflet-bottom.leaflet-right .leaflet-control-attribution {
  display: none;
  margin-bottom: 10px;
}
.logo-large {
  display: none;
}

.leaflet-container >>> .leaflet-pane {
  z-index: 50;
}
.disableDropdownMenu {
  display: none;
}

@media (max-width: 414px) {
  #top_div {
    overflow-x: auto;
    overflow-y: auto;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 700px;
    width: 65%;
  }
  .plugin-sidebar {
    overflow-x: auto;
    overflow-y: auto;
    width: 35%;
  }
}
</style>
<script >
//import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import axios from "axios";
import VueAxios from "vue-axios";
import vueDropdown from "../components/vue-dropdown/vue-mapdropdown";
import mapoptionsconfig from "@/components/vue-dropdown/config-mapoptions";
import keelungBus from "../data/keelungBus";
export default {
  name: "Map",
  components: {
    vueDropdown
    //LMap,
    //LTileLayer,
    //LMarker,
  },
  data() {
    return {
      responseData: "",
      busLocation: [],
      map: null,
      customLayer: [],
      mql: {},
      directions: {},
      isDisabled: false,
      config: mapoptionsconfig,
      color: "#5AB4D5", //default color
    };
  },
  methods: {
    setNewSelectedOption(selectedOption) {
      this.config.placeholder = selectedOption.value;
    },
    tagAllStops: function(event) {
      for (
        var i = 0;
        i < document.querySelectorAll(".disableDropdownMenu").length;
        i++
      ) {
        if (document.querySelectorAll(".disableDropdownMenu").length >= 0) {
          document
            .querySelectorAll(".disableDropdownMenu")
            [i].setAttribute("class", "dropdown-label-container");
          i = 0;
        }
      }
    },
    tagDowntown: function(event) {
      this.tagAllStops();
      for (
        var i = 0;
        i < document.querySelectorAll(".dropdown-label-container").length;
        i++
      ) {
        if (
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") !== null &&
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") != "市區"
        ) {
          document
            .querySelectorAll(".dropdown-label-container")
            [i].setAttribute("class", "disableDropdownMenu");
          i = 0;
        }
      }
    },
    tagNorthCoast: function(event) {
      this.tagAllStops();
      for (
        var i = 0;
        i < document.querySelectorAll(".dropdown-label-container").length;
        i++
      ) {
        if (
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") !== null &&
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") != "北海岸"
        ) {
          document
            .querySelectorAll(".dropdown-label-container")
            [i].setAttribute("class", "disableDropdownMenu");
          i = 0;
        }
      }
    },
    tagNortheastCorner: function(event) {
      this.tagAllStops();
      for (
        var i = 0;
        i < document.querySelectorAll(".dropdown-label-container").length;
        i++
      ) {
        if (
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") !== null &&
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") != "東北角"
        ) {
          document
            .querySelectorAll(".dropdown-label-container")
            [i].setAttribute("class", "disableDropdownMenu");
          i = 0;
        }
      }
    },
    tagMountainArea: function(event) {
      this.tagAllStops();
      for (
        var i = 0;
        i < document.querySelectorAll(".dropdown-label-container").length;
        i++
      ) {
        if (
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") !== null &&
          document
            .querySelectorAll(".dropdown-label-container")
            [i].getAttribute("tag") != "山區"
        ) {
          document
            .querySelectorAll(".dropdown-label-container")
            [i].setAttribute("class", "disableDropdownMenu");
          i = 0;
        }
      }
    },
    busLine: function(event) {
      let stopId = event.stopId;
      let value = event.value;
      this.color = event.color;
      let switchOpen = document.getElementById(stopId + "_" + value).checked;
      let allSameBusLine = document.getElementsByClassName(value);
      if (switchOpen == true) {
        this.createBusLine(value);
      } else {
        this.hideLayer(value);
      }
      for (let i = 0; i < allSameBusLine.length; i++) {
        if (switchOpen == true) {
          allSameBusLine[i].checked = true;
        } else {
          allSameBusLine[i].checked = false;
        }
      }
    },
    hideLayer(id) {
      let customIndex = this.directions[id].index;
      try {
        this.map.removeLayer(this.customLayer[customIndex]);
      } catch (e) {
        console.log("remove layer before create this layer id");
      }
      this.directions[id].show = false;
    },
    methodToRunOnSelect(payload) {
      this.object = payload;
    },
    createBusLine(id) {
      // this.config.options.forEach(stopValue => {
      this.responseData.forEach(element => {
        if (
          element.Direction == 0 &&
          id == element.RouteID.toString().slice(0, 3)
        ) {
          let directionKeys = Object.keys(this.directions);
          if (directionKeys.indexOf(id) >= 0) {
            // Just Add Same Route Value Bus Line for once
            if (this.directions[id].show == false) {
              this.customLayer[this.directions[id].index].addTo(this.map);
              this.directions[id].show = !this.directions[id].show;
            }
            return;
          }
          //Declare Direction
          let direction = L.mapquest.directions();
          let directionPosition = directionKeys.length;
          let locations = this.setBusLocation(element.Stops);
          //create route Direction and layer
          this.createRoute(direction, locations);

          //Add new direction from id (Bus Line value ex: 101, 103)
          this.directions[id] = {
            direction: direction,
            index: directionPosition, //add index to find layer from custom layer
            show: true
          };
        }
      });
      // });
    },
    createRoute(direction, busLocations) {
      direction.route(
        {
          waypoints: busLocations
        },
        this.createMap,
      );
    },
    setBusLocation(stops) {
      let busLocation = [];
      for (let i = 0; i < stops.length; i++) {
        busLocation.push([
          stops[i].StopPosition.PositionLat,
          stops[i].StopPosition.PositionLon
        ]);
      }
      return busLocation;
    },
    createMap(err, response) {
      let customLayer = L.mapquest.directionsLayer({
        startMarker: {
          iconOptions: {
            shadow: false
          }
        },
        endMarker: {
          iconOptions: {
            shadow: false
          }
        },
        waypointMarker: {
          icon: "circle",
          iconOptions: {
            size: "sm",
            primaryColor: "#1fc715",
            secondaryColor: "#1fc715",
            symbol: "A",
            shadow: false
          },
          title: "Drag to change location"
        },
        routeRibbon: {
          color: this.color,
          opacity: .8,
          showTraffic: false
        },
        directionsResponse: response
      });
      this.color = "#5AB4D5", //default color
      customLayer.addTo(this.map);
      this.customLayer.push(customLayer);
    }
  },
  created() {
    var self = this;
    window.addEventListener("load", () => {
      if (self.$router.history.current.name !== "home" || self.map != null) {
        return;
      }
      L.mapquest.key = "5jI3IRbTy6YUgQqSGFBU2AgLs5zTk7yY";
      self.map = L.mapquest.map("top_div", {
        layers: L.mapquest.tileLayer("map"),
        center: [25.1325037, 121.7402479],
        zoom: 12
      });
      this.responseData = keelungBus.keelungBus;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Map.vue